export class ItemsPerPage {
  constructor(
    public itemsPerPage?: number,
  ) { }

  clone() {
    return new ItemsPerPage(
      this.itemsPerPage
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/items-per-page.ts